module.exports = __webpack_public_path__ + "img/Evento2.e21d79b8.jpg";